(function () {
  if (window.__cartCrossSellInit) return;
  window.__cartCrossSellInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-cross-sell-add]');
    if (!btn || btn.disabled) return;

    var card = btn.closest('[data-cart-cross-sell]');
    var variantId = card && card.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      __volumeOfferBypass: true, // evite que le patch fetch de volume-offer.js ne reecrive cet appel
      __cartGuardBypass: true
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
